import { render, staticRenderFns } from "./ArrowCarouselNext.vue?vue&type=template&id=bbf3e168&"
import script from "./ArrowCarouselNext.vue?vue&type=script&lang=js&"
export * from "./ArrowCarouselNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports